module.exports = __webpack_public_path__ + "static/media/ly.8b64bcbd.svg";